import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '/panels': {
                params: { filter: 'local_page_id:$null' },
            },
            '/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '/customers': {
                params: { filter: 'registered:1' }
            },
            '/customer_downloads': {
                params: { sort: 'created_at:desc' }
            },
            '/customer_receipts': {
                params: { sort: 'created_at:desc' }
            },
            '/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            // '/blog': {
            //     params: { sort: 'available_at:desc' }
            // },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
            mp4: ['mp4', 'webm'],
        }
    },
    menu,
    notifications,
}
